<template>
  <div class="wdgt-container" ref="container">
    <span v-if="!customOrders" class="mb-3">{{ $t('messages.loading') }}</span>
    <span v-if="customOrders && customOrders.length === 0" class="mb-3">{{ $t('messages.emptyOrders') }}</span>
    <div class="clear-both"></div>
    <div class="msg">
      * {{ $t('messages.cancellationRequest') }} <a href="mailto:cancelaciones@visitarbodegas.com">cancelaciones@visitarbodegas.com</a> {{ $t('messages.cancellationRequest2') }}
    </div>
    <table v-if="customOrders && customOrders.length > 0">
      <thead>
        <tr>
          <th class="wdgt-date">{{ $t('words.date') }}</th>
          <th class="wdgt-status">{{ $t('words.status') }}</th>
          <!--th class="wdgt-paymentDate">{{ $t('words.paymentDate') }}</th-->
          <th class="paymentMethod">{{ $t('words.paymentMethod') }}</th>
          <th class="wdgt-total">{{ $t('words.total') }}</th>
          <th class="wdgt-download"></th>
          <th class="wdgt-details"></th>
          <!-- th class="wdgt-cancel"></th-->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in customOrders" :key="index+'-'+item.orderId">
          <td class="wdgt-date"> {{ formatDateTime(item.createdAt) }}</td>
          <td class="wdgt-status">{{ $t('_orderStatus.'+ item.status) }}</td>
          <!--td class="wdgt-paymentDate">{{ formatDateTime(item.paymentDate) }}</td-->
          <td class="paymentMethod">{{ $t('_paymentMethod.'+ item.paymentMethod) }}</td>
          <td class="wdgt-total">{{ formatCurrency(item.priceWithTaxes) }}</td>
          <td class="wdgt-download">
            <a v-if="item.invoice && item.invoice.fileId" style="cursor: pointer;" href="#" title="Descargar Factura" @click="downloadFile(item.invoice.fileId)">
              <i class="fa fa-download" /> Factura
            </a>
          </td>
          <td class="wdgt-details">
            <a v-if="item.status === 'refunded'" style="cursor: pointer;" href="#" title="Ver pedido" @click="setPreview(item, true)">
              <i class="fa fa-eye" /> Pedido
            </a>
            <a v-else style="cursor: pointer;" href="#" title="Ver pedido" @click="setPreview(item, false)">
              <i class="fa fa-eye" /> Pedido
            </a>
          </td>
          <!--td class="wdgt-cancel" v-if="item.status === 'paid'"><a>Cancelar pedido</a></th>
          <th class="wdgt-cancel" v-else></td-->
        </tr>
      </tbody>
    </table>
    <modal v-show="preview.show" hide-footer size="xl" id="modal-order-details" :title="preview.title" @close="preview.show = false">
      <template #header>
        <h3>{{preview.title}}</h3>
      </template>
      <template #body>
        <order-details v-if="preview.show" :order="preview.order" :ref="'orderDetails_' + preview.order.id" />
      </template>
    </modal>
  </div>
</template>
<script>
import OrderRepository from "@/api/OrderRepository";
import {downloadFile} from "@/utils/functions";
import orderDetails from '@/components/visitarbodegas/orderDetails';
import Modal from '@/components/modal';
import {filters, chainFilters} from "@/config/filters";

export default {
  props: {
    filters: { type:Object, required: false},
    orders: { type:Object, required: false}
  },
  components: {
    orderDetails,
    Modal
  },
  data() {
    return {
      customOrders : null,
      preview:{
        show:false,
        order:null,
        title:''
      },
    }
  },
  computed: {},
  created() {
    this.getOrders();
  },

  methods: {
    downloadFile,
    formatCurrency(value) {
      return filters.currency(value);
    },
    formatDateTime(value) {
      return chainFilters(value, 'toDate', 'dateTimeFormat');
    },
    async getOrders() {
      const response = await OrderRepository.customerOrders(this.filters,this.orders);
      this.customOrders = response.data.items;
    },
    setPreview(order, refund=false){
      this.preview.order = order;
      this.preview.show = true;
      this.preview.refund = refund;
      this.preview.title = this.preview.refund ? this.$t('words.refundDetails') : this.$t('words.orderDetails');
    },

  }
}
</script>

<style scoped>

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #dedede;
  border-right: none;
  border-bottom: none;
  border-radius: 5px;
  color: #464958;
  margin: auto auto 15px;
  font-size: 16px;
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}

thead {
  background-color: #fafafa;
}

th,
td {
  border: 1px solid #dedede;
  border-left: none;
  border-top: none;
  padding: 5px;
  vertical-align: middle;
}
</style>
